/**
 * @generated SignedSource<<df51d00f045ce956e80a335b3dc42e0b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSharedHeroCarousel_user$data = {
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedImageGalleryModal_user" | "RequestMoreImages_user" | "ViewInRoom_user">;
  readonly " $fragmentType": "PdpRespSharedHeroCarousel_user";
};
export type PdpRespSharedHeroCarousel_user$key = {
  readonly " $data"?: PdpRespSharedHeroCarousel_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedHeroCarousel_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSharedHeroCarousel_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ViewInRoom_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RequestMoreImages_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedImageGalleryModal_user"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "5f48350bf4518ed4be60ae95bb75dfb4";

export default node;
